import * as UserManagementApi from '../data/UserManagementApi';
import { Dispatch } from 'react';
import { IAction } from '../sections/new-user/context/useNewUserContext';
import { IUserData } from '../entities';

export const createUserAction = async (user: IUserData, dispatch: Dispatch<IAction>) => {
  await UserManagementApi.postUser(user)
    .then(res => {
      dispatch({
        type: 'CREATE_USER_SUCCESS',
        payload: { createdUser: res.entity, success: true, error: false, errorMessage: '' },
      });
    })
    .catch(err => {
      dispatch({ type: 'CLEAR_ERROR' });
      dispatch({
        type: 'CREATE_USER_FAIL',
        payload: { createdUser: null, success: false, error: true, errorMessage: err.message },
      });
    });
};

export default createUserAction;
